if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      imageUpdateVariant=[]

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
        const selectedLabel = this.querySelectorAll(".product-form__input--pill input[type=radio]:checked + label")[1] 
              ? this.querySelectorAll(".product-form__input--pill input[type=radio]:checked + label")[1] 
              : this.querySelectorAll(".product-form__input--pill input[type=radio]:checked + label")[0];
            if (selectedLabel) {
                this.imageUpdateVariant = selectedLabel.innerText; 
                const images = this.querySelectorAll('.thumbnail.global-media-settings img');
                const imageupdateVar = this.imageUpdateVariant.toLowerCase(); 
                const blueberryImages = Array.from(images).filter(img => 
                    img.alt.toLowerCase().includes(imageupdateVar?.split("\n")[0]?.trim())
                );
                Array.from(images).forEach(img => {
                    if (!blueberryImages?.includes(img)) {
                        img.parentNode.parentNode.style.display = "none"; 
                    }else{
                        img.parentNode.parentNode.style.display = "block"; 
                    }
                });
            } 
      }

     
      connectedCallback() {
        this.initializeProductSwapUtility();
        this.handleUpdateProductInfo();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
          this.handleUpdateProductInfo()
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const mobilePrice = html.querySelector(".price-item.price-item--sale.price-item--last");
            const pdpMobilePrice = document.querySelector(".pdp__mobile__atc-price");
          
          const mobileComparePrice = html.querySelector(".price__sale .price-item.price-item--regular");
          const pdpMobileComparePrice = document.querySelector(".pdp__mobile__atc-compare__price");
          
          if (mobilePrice && pdpMobilePrice && mobileComparePrice && pdpMobileComparePrice) {
            // Update innerHTMLs
            pdpMobilePrice.innerHTML = mobilePrice.innerHTML;
            pdpMobileComparePrice.innerHTML = mobileComparePrice.innerHTML;
          
            // Extract numeric values
            const salePrice = parseFloat(mobilePrice.innerText.replace(/[^\d.]/g, ""));
            const regularPrice = parseFloat(mobileComparePrice.innerText.replace(/[^\d.]/g, ""));
          
          if (!isNaN(salePrice) && !isNaN(regularPrice) && regularPrice > salePrice) {
              const discount = ((regularPrice - salePrice) / regularPrice) * 100;
              const firstTwoDigits = discount.toString().replace('.', '').slice(0, 2);
            
              const mobileDiscount = document.querySelector(".pdp__mobile__atc-discount");
              mobileDiscount
                ? (mobileDiscount.innerHTML = `${firstTwoDigits}% Off`)
                : console.warn("⚠️ Element .pdp__mobile__atc-discount not found.");            
            }
      
          } else {
            console.warn("⚠️ One or more price elements are missing in the DOM.");
          }

            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const targetForm = document.querySelector("product-info");
        const sourceForm = productInfoNode.querySelector("product-info");
        if (targetForm && sourceForm) {
          targetForm.replaceWith(sourceForm.cloneNode(true));
        }
        
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }
      
      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
            const selectedLabel = this.querySelectorAll(".product-form__input--pill input[type=radio]:checked + label")[1]
              ? this.querySelectorAll(".product-form__input--pill input[type=radio]:checked + label")[1] 
              : this.querySelectorAll(".product-form__input--pill input[type=radio]:checked + label")[0];
            if (selectedLabel) {
                this.imageUpdateVariant = selectedLabel.innerText; // Use the selected label's text
                const images = this.querySelectorAll('.thumbnail.global-media-settings img');
                const imageupdateVar = this.imageUpdateVariant.toLowerCase(); // Convert to lowercase
        
                const blueberryImages = Array.from(images).filter(img => 
                    img.alt.toLowerCase().includes(imageupdateVar?.split("\n")[0]?.trim())
                );

            
                
                Array.from(images).forEach(img => {
                    if (blueberryImages.includes(img)) {
                        img.parentNode.parentNode.style.display = "block"; 
                    } else {
                        img.parentNode.parentNode.style.display = "none"; 
                    }
                });
            } 


          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
        // Update the canonical URL
        let canonicalUrl = `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`;
        document.querySelector('link[rel="canonical"]').setAttribute('href', canonicalUrl);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

setTimeout(()=>{
  const buttons = document.querySelectorAll(".product--thumbnail_slider .thumbnail-slider button");
  buttons?.forEach(button => {
      button?.removeAttribute("disabled");
  });

},1500);


const tabThumbItems = document.querySelectorAll(".accordion-thumb");
for (let tab of tabThumbItems) {
   tab.addEventListener("click", () => {
       let panel = tab.parentNode.querySelector(".accordion-panel");
       if (panel.classList.contains("active")) {
           panel.classList.remove("active");
       } else {
           panel.classList.add("active");
       }
   });
}

let shareIcon = document.querySelector(".share__and__wishlist__icon .share__icon");
shareIcon?.addEventListener("click",()=>{
 document.querySelector(".share-button__button")?.click();
});

class Pincode extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.countdownInterval = null;
    this.validPincodes = [];
  }

  async connectedCallback() {
    this.render();
    await this.handlePincodeData();
    this.attachEventListeners();
  }


  async handlePincodeData() {
    // console.log('Valid Pincodes:', this.validPincodes);
  }

  attachEventListeners() {
    const pincodeCheck = this.querySelector(".pincode_check_btn");
    const pincodeInput = this.querySelector(".pincode__checker input[type=number]");
    const pincodeErrorMess = this.querySelector(".pincode__error");
    const pincodeDeliveryText = this.querySelector(".pincode__same__day__delivery__text");
    const pincodeElement = this.querySelector(".pincode__green__text");


  if (!pincodeCheck || !pincodeInput) {
    console.error("❌ Required elements not found!");
    return;
  }

pincodeCheck.addEventListener("click", async () => {
  let inputValue = pincodeInput.value.trim();

  if (inputValue.length !== 6) {
    console.error("❌ Pincode must be exactly 6 digits.");
    return;
  }
  updateDeliveryMessage("⏳ Checking availability...", "success");
  pincodeCheck.setAttribute("disabled", "disabled");

  try {
    const ITHINK_ACCESS_TOKEN = "372320bf9e8c53f178d3fe002d1d8204";
    const ITHINK_SECRET_KEY = "a8a6bfc65ef30d248ef4b639c6cecd13";

    const response = await fetch("https://my.ithinklogistics.com/api_v3/pincode/check.json", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: {
          pincode: inputValue,
          access_token: ITHINK_ACCESS_TOKEN,
          secret_key: ITHINK_SECRET_KEY,
        },
      }),
    });

    if (!response.ok) {
      throw new Error("API error: " + response.status);
    }

    const data = await response.json();

    if (data.status === "error") {
      updateDeliveryMessage("❌ Invalid or unserviceable pincode.");
      return;
    }

    const deliveryData = data?.data?.[inputValue] || null;

    if (deliveryData) {
      let remark = deliveryData.remark || "";

      // Extract date from remark (e.g. "Expected delivery on 2025-09-22")
      let dateMatch = remark.match(/\d{4}-\d{2}-\d{2}/);
      let formattedRemark = remark;

    if (dateMatch) {
        let date = new Date(dateMatch[0]);

        // Format with comma after weekday and short month
        let formatted = date.toLocaleDateString("en-GB", {
          weekday: "long",
          day: "2-digit",
          month: "short", // Short month like Jan, Jun, Sep
          year: "numeric"
        });

        // Add comma after weekday (e.g. "Friday, 21 Sep 2025")
        let parts = formatted.split(" ");
        let weekday = parts[0].replace(",", "");
        let rest = parts.slice(1).join(" ");
        formattedRemark = `${weekday}, ${rest}`;
      }
      setTimeout(()=>{
      updateDeliveryMessage(`
        <div class="delivery-success">
          <div class="delivery-main">
            <img src="https://cdn.shopify.com/s/files/1/0057/8938/4802/files/Mask_group-10.png?v=1677571152"
                width="14"
                height="14"
                alt="Verified"
                class="delivery-icon">

            <span>
              <strong>Expected delivery:</strong> ${formattedRemark}
            </span>
          </div>

          <div class="delivery-note">
            *Delivery may be delayed due to unforeseen circumstances.
          </div>
        </div>
      `);
      },1000);
      return;
    }

    updateDeliveryMessage("❌ Pincode not serviceable.");
  } catch (error) {
    console.error("❌ API Fetch Error:", error);
    updateDeliveryMessage("❌ Something went wrong. Please try again.");
  } finally {
    setTimeout(() => pincodeCheck.removeAttribute("disabled"), 500);
  }
});


function updateDeliveryMessage(message) {
  const messageElement = document.getElementById("deliveryMessage");
  messageElement.innerHTML = message;
}

function formatDate(remark) {
  let formattedDate = new Date(remark).toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
  return formattedDate;
}


function updateDeliveryMessage(message) {
  const deliverySection = document.querySelector(".delivery-section");
  if (!deliverySection) {
    console.error("❌ Delivery section not found.");
    return;
  }
  deliverySection.innerHTML = `<div class="delivery-message success"><span class="main__pincode__message">${message}</span></div>`;
}

function formatDate(remark) {
  let dateMatch = remark.match(/\d{4}-\d{2}-\d{2}/);
  let date = dateMatch ? new Date(dateMatch[0]) : new Date();

  // If no valid date is found, set to next day
  if (!dateMatch) {
    date.setDate(date.getDate() + 1);
  }

  return date.toLocaleDateString("en-GB", { 
    weekday: "short", 
    day: "2-digit", 
    month: "long", 
    year: "numeric" 
  });
}



pincodeInput.addEventListener("input", () => {
  let inputValue = pincodeInput.value.trim();

  // Limit input to 6 digits
  if (inputValue.length > 6) {
    inputValue = inputValue.slice(0, 6);
    pincodeInput.value = inputValue;
  }

  const isValidLength = inputValue.length === 6;
  const isEmpty = inputValue === "";
  const isValidPincode = this.validPincodes.includes(inputValue);

  // Clear content if input is empty
  if (isEmpty) {
    pincodeErrorMess.classList.add("hide");
    pincodeDeliveryText?.classList.add("hide");
    document.querySelector(".delivery-section").innerHTML = "";
    return;
  }

  // Handle valid pincode or 6-digit input
  if (isValidLength) {
    pincodeErrorMess.classList.add("hide");
    pincodeDeliveryText?.classList.add("hide");
    return;
  }

  // Show error for invalid and incomplete input
  pincodeErrorMess.classList.remove("hide");
  pincodeDeliveryText?.classList.add("hide");
});
    
// const apiTrack = () => {
//   const isTracked = sessionStorage.getItem("userIp");
//   if (isTracked) return; // Already tracked during this session

//   // Step 1: Get IP and location info
//   fetch("https://ipapi.co/json/")
//     .then((res) => res.json())
//     .then((data) => {
//       const userIp = data.ip;

//       // Step 2: Send IP to backend
//       fetch("https://admin.boltnutritions.com/api/track-visit", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ip: userIp }),
//       })
//         .then((response) => response.json())
//         .then((result) => {
//           console.log(result.message);
//           sessionStorage.setItem("userIp", "true");
//         })
//         .catch((error) => console.error("Error tracking visit:", error));
//     })
//     .catch((err) => {
//       console.error("Failed to get IP address:", err);
//     });
// };


  }

  startCountdown(duration, pincodeElement) {
    let timeRemaining = duration;

    const updateCountdown = () => {
      if (timeRemaining <= 0) {
        pincodeElement.innerHTML = "Time's up!";
        clearInterval(this.countdownInterval);
        return;
      }

      const hours = Math.floor(timeRemaining / 3600);
      const minutes = Math.floor((timeRemaining % 3600) / 60);
      const seconds = timeRemaining % 60;

      const timeString = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      pincodeElement.innerHTML = timeString;
      timeRemaining--;
    };

    this.countdownInterval = setInterval(updateCountdown, 1000);
  }

  render() {
    // console.log("Pincode component rendered");
  }

  disconnectedCallback() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}

customElements.define('pincode-element', Pincode);


function addBadgeToProfiles() {
  const profileDivs = document.querySelectorAll('.jdgm-row-profile');
  const badgeHTML = `
    <span class="jdgm-rev__buyer-badge-wrapper">
      <span class="jdgm-rev__buyer-badge"></span>
    </span>
  `;
  
  profileDivs.forEach(profile => {
    if (badgeHTML) {
      profile.innerHTML += badgeHTML;
    }
  });
}

setTimeout(() => {
  addBadgeToProfiles();
}, 2000);

let activeDataReview = document.querySelector(".jdgm-paginate__page.jdgm-curt");
document.querySelector("#judgeme_product_reviews").addEventListener("click", (event) => {
  if (event.target && event.target.classList.contains("jdgm-paginate__page")) {
   setTimeout(() => {
        addBadgeToProfiles();
    },800);
  }
});

// Override script creation to block specific FontAwesome kit
const originalCreateElement = document.createElement;
document.createElement = function (tag) {
  const element = originalCreateElement.call(this, tag);
  if (tag === 'script') {
    const originalSetAttribute = element.setAttribute;
    element.setAttribute = function (name, value) {
      if (
        name === 'src' &&
        value.includes('kit.fontawesome.com/2640aa91b4.js')
      ) {
        return; // Prevent setting the src
      }
      return originalSetAttribute.call(this, name, value);
    };
  }
  return element;
};

